import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import InfoIcon from '@static/img/icons/info.svg';
import styles from './style.module.scss';
import Link from '@components/Link';

const EmptyList: PageComponent = () => {
    return (
        <div className={styles.empty_placeholder}>
            <div className={styles.placeholder_inner}>
                <InfoIcon />
                <h1>
                    <Trans
                        i18nKey="services.list.noServers.title"
                        ns="uiServicesMain"
                    >
                        Informacijos nėra
                    </Trans>
                </h1>
                <h2>
                    <Trans
                        i18nKey="services.list.noServers.desc"
                        ns="uiServicesMain"
                    >
                        Jus neturite nei vienos paslaugos
                    </Trans>
                </h2>
                <Link href="ui_order">
                    <a className="btn btn-primary btn-ms col-lg-3">
                        <Trans i18nKey="services.list.noServers.buttonGoToOrder" ns="uiServicesMain">
                            Užsakyti dabar
                        </Trans>
                    </a>
                </Link>
            </div>
        </div>
    );
};

export default EmptyList;
